<template>
<div class="footer">

    <!-- <Newsletter/> -->

    <div class="links-wrap">
        <p class="minor col2">
            <span>© 2020</span>
            <!-- <a class="button-text hover-margin-lt" href="http://www.mesh-innovation.com" target="_blank">
                <span>Mesh Innovation</span>
            </a> -->
        </p>
        <p class="minor col2">
            <a @click="toggleLegal('terms')" class="button-text hover-margin-lt">
                <span>Terms</span>
            </a>
            <a @click="toggleLegal('privacy')" class="button-text hover-margin-lt">
                <span>Privacy</span>
            </a>
            <a @click="toggleLegal('cookies')" class="button-text hover-margin-lt">
                <span>Cookies</span>
            </a>
        </p>
        <p class="minor col2">
            <span>Site by</span>
            <a class="button-text hover-margin-lt" href="https://mesh-innovation.com" target="_blank">
                <span>MESH</span>
            </a>
        </p>
        <p class="minor col2 social">
            <span>Follow</span>
            <a class="button-text hover-margin-lt" href="https://www.instagram.com/formation.network/" target="_blank">
                <span>Instagram</span>
            </a>
            <a class="button-text hover-margin-lt" href="https://communityinviter.com/apps/formation-fyi/formation" target="_blank">
                <span>Slack (feedback)</span>
            </a>
            <a class="button-text hover-margin-lt" href="https://twitter.com/formation_fyi" target="_blank">
                <span>Twitter</span>
            </a>
        </p>
        <p class="minor col2">
            <a class="button-text" @click="scrollToTop">
                <span>To Top ↑↑↑</span>
            </a>
        </p>
    </div>

</div>
</template>

<script>
import Newsletter from '@/components/Newsletter.vue'
export default {
  name: 'Footer',
  components: {
      Newsletter,
  },
  methods: {
    toggleLegal(payload) {
      this.$store.commit('toggleLegal', payload)
    },
    scrollToTop() {
        window.scrollTo({
          top: 0, 
          left: 0, 
          behavior: 'smooth'
        });
    }
  }
}
</script>
<style lang="scss" scoped>

.footer {
    background-color: $white;
    padding: $grid-padding;
    box-sizing: border-box;
    height: calc(#{$monster-btn} * 2);
    position: relative;
    z-index: 11;
    .links-wrap {
        display: flex;
        align-items: flex-end;
        height: 100%;
        .col2 {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            white-space: pre;
            &:last-child {
                width: auto;
                margin-left: auto;
                text-align: right;
                margin-right: 0;
            }
        }
        .social {
            align-self: center;
        }
    }
}

// MOBILE
@media #{$mobile} {
    .footer {
        padding: $main-margin-mobile $main-margin-mobile 20px $main-margin-mobile;
    }
        
}

</style>
